export const validateMimeType = (file, mimeType) => {
  return file != null && mimeType.includes(file[0].type)
}
